import classnames from 'classnames'
import Avatar from 'components/lib/Avatar'
import FallbackBotAvatar from 'components/lib/icons/DefaultBotAvatar'
import useRecipientResolution from 'hooks/useRecipientResolution'
import useThemeColors from 'hooks/useThemeColors'
import { pathOr } from 'ramda'
import React, { useMemo } from 'react'

import './style.css'


interface RecipientAvatarProps {
  size?: string,
  id?: any,
  className?: string,
  avatarClassName?: string,
  image?: string
}

const AgentAvatar = ({ className, avatarClassName, size, image, name }) => (
  <div className={classnames("drift-widget-recipient-avatar", className)}>
    <Avatar size={size} image={image} aria-label={`${name} avatar`} className={avatarClassName} />
  </div>
)

const DefaultBotAvatar = ({ size, name, style }) => {
  return (
    <div style={style} className={classnames("drift-widget-default-bot-avatar drift-widget-recipient-avatar", {
      "drift-widget-default-bot-avatar--small": size === "SMALL",
      "drift-widget-default-bot-avatar--medium": size === "MEDIUM",
      "drift-widget-default-bot-avatar--large": size === "LARGE"
    })}>
      <FallbackBotAvatar  aria-label={`${name} avatar`}/>
    </div>
  )
}


const RecipientAvatar = ({ size = 'LARGE', id = null, className, avatarClassName, image }: RecipientAvatarProps) => {
  const { recipient } = useRecipientResolution(id)
  const agentAvatar = useMemo(() => pathOr(null, ['avatarUrl'], recipient), [recipient])
  const isBotAvatar = useMemo(() => pathOr(false, ['bot'], recipient), [recipient])
  const { defaultBotAvatarBackgroundStyles } = useThemeColors()

  if (!agentAvatar && isBotAvatar) {
    return (
      <DefaultBotAvatar size={size} name={recipient.name} style={defaultBotAvatarBackgroundStyles}/>
    )
  }

  return (
      <AgentAvatar
        size={size}
        image={image || agentAvatar}
        name={recipient.name}
        avatarClassName={avatarClassName}
        className={className} />
  )
}


export default RecipientAvatar
